export default __webpack_public_path__ + "static/media/opa-congressional-outreach-header.31c87b1f.png";